import React from "react";
import Col from "react-bootstrap/Col";
import Container from 'react-bootstrap/Container';
import Row from "react-bootstrap/Row";
import { Dropdown, ButtonGroup, Button } from "react-bootstrap";
import * as DOMPurify from 'dompurify';

import {myGlobals, myUtilities} from '../../Utils'

class TopBuildInputField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: "",
      currency: myGlobals.selectedPoaCurrency,
      isFieldError: false,
      dropdownfieldsValue: {}
    };
    this.myref = React.createRef();
    this.parentInputRef = React.createRef();
  }

  handleChange = (event) => {
    let value = event.target.value;
    if (myGlobals.charactersToBlackList.test(value)) {
      myUtilities.addNotification(event);
      return;
    }
    // if(this.props.name.localeCompare('emailId')===0){
    //   const regex = RegExp('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,8}$');
    //   if(regex.test(event.target.value))
    //     this.myref.current.setCustomValidity('');
    //   else
    //     this.myref.current.setCustomValidity(' ');
    // }
    // else
    this.myref.current.setCustomValidity("");
    if (this.props.isRequired && value.trim() == "") {
      event.target.value = "";
      this.myref.current.setCustomValidity(" ");
    }
    if (!this.props.isNumber) {
      let value = event.target.value;
      this.setState({
        value: event.target.value,
      });
      this.props.formSetState(this.props.name, event.target.value);
    } else {
      let value = event.target.value;
      if (isNaN(value)) value = this.state.value;
      this.props.formSetState(this.props.name, parseFloat(value));
      if (value === 0)
        this.setState({
          value: "",
        });
      else
        this.setState({
          value: value,
        });
    }
  };

  showDropDown = () => {
    let dropdownStr = myGlobals.poaCurrencies;
      const strArr = dropdownStr.split(",");
      const listItems = strArr.map((dropdownValue) => {
        return (
          <Dropdown.Item
            className={dropdownValue === this.state.currency ? "clicked" : ""}
            key={dropdownValue}
            eventKey={dropdownValue}
          >
            {dropdownValue}
          </Dropdown.Item>
        );
      });
      if (this.props.showDropDown) {
        return (
          <React.Fragment>
            {this.createDropdown(listItems)}
          </React.Fragment>
        );
      }
  };
  dropDownClass = () => {
    if (this.props.showDropDown) {
      return "topbuild-input-label-dropdown";
    } else return "topbuild-input-label";
  };
  addTrifectaMandateCheck = () => {
	    this.state.isFieldError &&
	      this.state.value === "" &&
	      this.parentInputRef.current.classList.add("mandatoryFieldError");

	    this.state.isFieldError &&
	      this.state.value !== "" &&
	      this.parentInputRef.current.classList.remove("mandatoryFieldError");
	    
	    this.state.isFieldError &&
	      this.state.value === "" &&
	      this.props.showDropDown &&
	      this.parentInputRef.current.classList.add("mandatoryFieldError-drop");

	    return (
	      this.state.isFieldError &&
	      this.state.value === "" &&
	      myGlobals.currentTheme === "trifectaTheme.css" && (
	        <div class="missed-field">
	          <div className="exclamation" />
	          <span class="tooltiptext">
            {myUtilities.accountSpecificLanguage("form.validation.error",
	              "Please fill out this field.")}
	          </span>
	        </div>
	      )
	    );
	  };
  chnageDropDownVal = (value) => {
	    this.setState({ currency: value });
	    myGlobals.selectedPoaCurrency = value;
  };
  createDropdown = (listItems) => {
	    return (
	      <Dropdown
	        id="input-dropdown"
	        onSelect={(data) => this.chnageDropDownVal(data)}
	        as={ButtonGroup}
          drop="down"
	      >
	        <Dropdown.Toggle split variant="success" id="dropdown-split-basic">
	          {this.state.currency}
	        </Dropdown.Toggle>
	        <Dropdown.Menu id="input-dropdown-menu">{listItems}</Dropdown.Menu>
	      </Dropdown>
	    );
	  };
  showValidationMessage = () =>
    this.state.value === ""
      ? myUtilities.accountSpecificLanguage( "form.validation.error", "Please fill out this field.")
      : "";

  inputBasedOnIsNumber = () => {
    if (
      this.props.name.localeCompare("emailId") === 0 &&
      !this.props.isRequired
    ) {
      return (
        <input
          ref={this.myref}
          value={this.state.value}
          name={this.props.name}
          className={this.dropDownClass()}
          type="text"
          onChange={(event) => {
            this.handleChange(event);
          }}
        />
      );
    } else if (
      this.props.name.localeCompare("emailId") === 0 &&
      this.props.isRequired
    ) {
      return (<>
        <input
          ref={this.myref}
          title={this.showValidationMessage()}
          onInvalid={() =>{
        	this.setState({ isFieldError: true });
            return this.myref.current.setCustomValidity(
              myUtilities.accountSpecificLanguage( "form.validation.error",
               "Please fill out this field."))
              }
          }
          value={this.state.value}
          required
          name={this.props.name}
          className={this.dropDownClass()}
          type="text"
          onChange={(event) => {
            this.handleChange(event);
          }}
        />{this.addTrifectaMandateCheck()}</>
      );
    } else if (!this.props.isNumber && !this.props.isRequired) {
      return (
        <input
          ref={this.myref}
          value={this.state.value}
          name={this.props.name}
          className={this.dropDownClass()}
          type="input"
          onChange={(event) => {
            this.handleChange(event);
          }}
        />
      );
    } else if (!this.props.isNumber && this.props.isRequired) {
      return (<>
        <input
          ref={this.myref}
          title={this.showValidationMessage()}
          onInvalid={() => {
        	this.setState({ isFieldError: true });
            return this.myref.current.setCustomValidity(
              myUtilities.accountSpecificLanguage("form.validation.error"
                , "Please fill out this field."))
            }
          }
          value={this.state.value}
          required
          name={this.props.name}
          className={this.dropDownClass()}
          type="input"
          onChange={(event) => {
            this.handleChange(event);
          }}
        />{this.addTrifectaMandateCheck()}</>
      );
    } else if (!this.props.isRequired && this.props.isNumber) {
      return (
        <input
          ref={this.myref}
          value={this.state.value}
          name={this.props.name}
          className={this.dropDownClass()}
          type="number"
          onChange={(event) => {
            this.handleChange(event);
          }}
        />
      );
    } 
    else if (this.props.isRequired && this.props.isNumber) {
    	return (<>
        <input
          ref={this.myref}
          title={this.showValidationMessage()}
          onInvalid={() => {
        	this.setState({ isFieldError: true });
            return this.myref.current.setCustomValidity(
              myUtilities.accountSpecificLanguage("form.validation.error"
                , "Please fill out this field."))
            }
          }
          value={this.state.value}
          required
          name={this.props.name}
          className={this.dropDownClass()}
          type="number"
          onChange={(event) => {
            this.handleChange(event);
          }}
        />{this.addTrifectaMandateCheck()}</>
      );
      }
    else {
      return (<>
        <input
          ref={this.myref}
          title={this.showValidationMessage()}
          onInvalid={() => {
        	  this.setState({ isFieldError: true });
            return this.myref.current.setCustomValidity(
              myUtilities.accountSpecificLanguage("form.validation.error",
                "Please fill out this field."))
              }
          }
          required
          value={this.state.value}
          name={this.props.name}
          className={this.dropDownClass()}
          type="input"
          onChange={(event) => {
            this.handleChange(event);
          }}
        /> {this.addTrifectaMandateCheck()}</>
      );
    }
  };
  isTopBuildInvoice = () => {
    if (this.props.isTopBuildInvoice) return 5;
    else return 4;
  };

  renderAsteric = () =>
	  this.props.isRequired ? (
	    <>
	      <span class="red-asterisk">*</span> :
	    </>
	  ) : (
	    " :"
	  );

    changeDropdown = (key,value) => {
      this.setState({ dropdownfieldsValue: {...this.state.dropdownfieldsValue, [key]: value} });
      this.props.formSetState(key,value)
    }

    createDropdownField = (name, dropDownValues) => {
      const dropDownValuesLocal = Array.isArray(dropDownValues) ? [...dropDownValues] : [];
      dropDownValuesLocal.unshift({key:"", value: ""});
	    return (
        <Dropdown as={ButtonGroup} onSelect={(value) => this.changeDropdown(name, value)}>
          <Button variant="success" className="field-dropdown">{this.state.dropdownfieldsValue[name] ?? ""}</Button>
          <Dropdown.Toggle split variant="success" id="dropdown-split-basic" className="field-dropdown-toggle"/>
	        <Dropdown.Menu> {
             dropDownValuesLocal?.map((dropdownValue) => 
                      <Dropdown.Item
                        className="field-dropdown-item"
                        key={DOMPurify.sanitize(dropdownValue.key)}
                        eventKey={DOMPurify.sanitize(dropdownValue.key)}
                      >
                        {dropdownValue.key}
                      </Dropdown.Item>
                    )
          }</Dropdown.Menu>
	      </Dropdown>
	    );
	  };

  render() {
    return (
      <Container>
        <Row className="topbuild-input">
          <Col
            xs={this.isTopBuildInvoice()}
            sm={4}
            className="topbuild-input-label-header"
          >
            {this.props.label}
            {this.renderAsteric()}
          </Col>
          <Col ref={this.parentInputRef}  xs={12 - this.isTopBuildInvoice()} sm={8}>
            {!(this.props.isDropdownField && this.props.dropDownValues?.length > 0) ? this.inputBasedOnIsNumber() : this.createDropdownField(this.props.name,this.props.dropDownValues)}
            {this.showDropDown()}
          </Col>
        </Row>
      </Container>
    );
  }
}

export default TopBuildInputField;
